<template>
  <div>
    <div class="sku-list">
      <CartSku
        v-for="sku in skuList"
        :key="sku.skuId"
        :item="sku"
      />
    </div>
    <div
      v-if="isAllEmpty"
      class="empty-cart"
    >
      <img
        src="@/assets/order/empty-cart.svg"
        alt=""
      >
      <div class="empty-text">
        Your cart is empty.
      </div>
    </div>
    <ProcessingDialog
      :visible="showProcessingDialog"
      @close="showProcessingDialog = false"
    />
  </div>
</template>

<script setup>
import { bankersRoundWithMax } from '@/utils/utils'
import CartSku from './CartSku.vue'
import { useCart } from '@/views/Carts/hooks/useCart'
import { useCartStore } from '@/pinia/cart'
import { useCurrencyStore } from '@/pinia/currency'
import ProcessingDialog from './ProcessingDialog.vue'

const emit = defineEmits(['totalChange'])

const cartStore = useCartStore()
const currency = useCurrencyStore()

const showProcessingDialog = ref(false)

const { cartList, isAllEmpty, getCartList } = useCart()

const skuList = computed(() => cartList.value.map(item => item.skuDetails).flat())

const topSubtotal = computed(() => {
  let total = 0
  skuList.value.forEach((v) => {
    if (v.checked) {
      total += bankersRoundWithMax(currency.current.rate * v.price, 0.01) * v.quantity
    }
  })
  return total.toFixed(2)
})

watch(topSubtotal, (val) => {
  emit('totalChange', val)
})

watch(() => cartStore.cartCount, (value) => {
  if (value) {
    getCartList()
  }
})
</script>

<style lang="less" scoped>
.sku-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 8px;
}
.empty-cart {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .empty-text {
    color: #232323;
    font-size: 11px;
    font-family: mon-500;
    line-height: 14px;
  }
  .sign-text {
    text-decoration: underline;
    margin-top: 4px;
    color: #009de0;
    font-size: 11px;
    font-family: mon-600;
    line-height: 14px;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
